import { css } from 'styled-components';
import { BodyProps, TableCellProps } from './models';
import { Divider, TableCell as _TableCell, TableRow as _TableRow } from '../../styles';

export const Body = css<BodyProps>(({ theme }) => {
  return css`
    width: 100%;

    & tr:hover td {
      background-color: #F2F4F7;
    }
  `;
});

export const TableRow = css(({ theme }: { theme }) => {
  return css`
    ${_TableRow};
    height: 48px;
    align-items: end;
    ${Divider};

    &:hover {
      background-color: #F2F4F7;
    }
  `;
});

export const TableExpandableRow = css(({ theme }: { theme }) => {
  return css`
    ${_TableRow};
    height: auto;
    align-items: end;
    background-color: #fff !important;
  `;
});

export const TableExpandableCell = css(({ theme }: { theme }) => {
  return css`
    width: 100%;
    background-color: #fff !important;
    height: 100%;
  `;
});

export const TableSmallCell = css(({ theme }: { theme }) => {
  return css`
    ${_TableCell};
    background-color: #fff;
    max-width: 20px;
    min-width: 20px;
    width: 20px;

    > .cell-container {
      display: flex;

      > .icon-container {
        align-self: center;
      }

    }
  `;
});

export const TableCell = css<TableCellProps>(({
                                                theme,
                                                cellAmount,
                                                isText,
                                                isGrouped,
                                                isExpanded,
                                                cellIndex,
                                                groupBy,
                                                isGroupedCell
                                              }: {
  theme,
  cellAmount: number,
  isText: boolean,
  isGrouped: boolean,
  isExpanded: boolean,
  cellIndex: number,
  groupBy: string,
  isGroupedCell: boolean
}) => {

  return css`
    ${_TableCell};
    font-weight: 400;
    line-height: 18px;
    align-items: center;
    width: calc(100% / ${cellAmount});
    text-align: ${isText ? 'start' : 'center'};
    background-color: ${isGrouped && isExpanded ? '#F2F4F7' : cellIndex % 2 === 0 ? '#fff' : '#FAFBFC'};
    max-width: calc(100% / ${cellAmount}) !important;
    min-width: 150px;

    &:first-child {
      justify-content: start;
      background-color: ${!(isGrouped && isExpanded) && groupBy && !isGroupedCell && '#fff'};
      border: ${!(isGrouped && isExpanded) && groupBy && !isGroupedCell && '0'};
      border-top: ${isExpanded && isGrouped && `1px solid #D9DEE8`};
      border-top: ${isGrouped && isGroupedCell && `1px solid #D9DEE8`};
    }

    > .group-container {
      display: flex;

      > .icon-container {
        align-self: center;
      }
    }
  `;
});